export default __webpack_public_path__ + "static/media/invite-flow.edcc35fd.png";